import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  paper: {
    width: "340px",
    padding: "12px 15px",
    borderRadius: "8px",
  },
  list: {
    padding: "5px 0",
    marginBottom: "10px",
    "& > li": {
      padding: 0,
      "& > div": {
        margin: 0,
      },
    },
  },
  fieldInfo: {
    "& > *": {
      paddingBottom: "5px",
    },
  },
}));
